import {
  Button,
  ButtonProps,
  Switch,
  Text,
  TextProps,
  SwitchProps,
} from "@ttc3k/trekker";
import { ReactNode } from "react";
import { Box, Flex, styled } from "styled-system/jsx";

const CardContainer = styled(Flex, {
  base: {
    borderRadius: "100",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "border.light",
    outlineWidth: "1px",
    outlineStyle: "solid",
    outlineColor: "transparent",
    py: "250",
    px: "300",
    bg: "white",
    justifyContent: "space-between",
    transitionProperty: "border-color, outline-color",
    transitionDuration: "150ms",
    transitionTimingFunction: "ease-in-out",
  },
  variants: {
    visual: {
      default: {},
      selected: {
        borderColor: "border.dark",
        outlineColor: "border.dark",
      },
    },
  },
});

type SelectableSwitchCardProps = {
  isSelected: boolean;
  onToggleSwitch: () => void;
  title: string;
  subtitleProps?: TextProps;
  buttonProps?: ButtonProps;
  switchProps?: SwitchProps;
  /** Extra content rendered below the main row, inside the card border. */
  footer?: ReactNode;
};

export const SelectableSwitchCard = ({
  isSelected,
  onToggleSwitch,
  title,
  subtitleProps,
  buttonProps,
  switchProps,
  footer,
}: SelectableSwitchCardProps) => {
  return (
    <CardContainer
      visual={isSelected ? "selected" : "default"}
      flexDirection={"column"}
      gap={"200"}
    >
      <Flex justifyContent={"space-between"}>
        <Flex flexDirection={"column"} gap={"50"}>
          <Text
            visual={"bodySemiBold"}
            color={"text.dark"}
            textTransform={"capitalize"}
            lineClamp={1}
          >
            {title}
          </Text>
          {subtitleProps && (
            <Text
              visual={"smallMedium"}
              color={"text.mid"}
              {...subtitleProps}
            />
          )}
        </Flex>

        <Flex gap={"200"} alignItems={"center"}>
          {buttonProps && (
            <>
              <Button {...buttonProps} />
              <Box
                h={"20px"}
                borderLeftWidth={"2px"}
                borderColor={"border.light"}
                borderRadius={"full"}
              />
            </>
          )}
          <Switch
            checked={isSelected}
            onCheckedChange={onToggleSwitch}
            {...switchProps}
          />
        </Flex>
      </Flex>

      {footer}
    </CardContainer>
  );
};
